import React, { useState, useEffect, useCallback } from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { MdDelete } from 'react-icons/md';
import { FormControl } from 'react-bootstrap';
import axios from 'axios';
import authHeader from '../services/AuthHeader';
import _ from 'lodash';

const DragDropCandidates = (props) => {
  props.allCandidates.map((k) => {
    return k;
  });

  const initial = props.allCandidates.map((k) => {
    const custom = {
      ballotCandidateId: k.ballotCandidateId,
      ballotCandidateName: k.ballotCandidateName,
      ballotCandidatePartyName: k.ballotCandidatePartyName,
      ballotCandidatePartyId: k.ballotCandidatePartyId,
    };

    return custom;
  });

  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    props.setBallotData((prev) => {
      prev.allBallots[props.outerIndex].allCandidates = result;
      const update = {
        ...prev,
        allBallots: prev.allBallots,
      };
      return update;
    });

    return result;
  };

  const deleteCandidate = (ballotCandidateId) => {
    axios
      .delete(
        process.env.REACT_APP_API_BASE + 'ballotCandidate/' + ballotCandidateId,
        {
          headers: authHeader(),
        }
      )
      .then(props.setRerender(true));
  };
  //
  const onChangeHandleCandidates = (evt, name, ballotCandidateId) => {
    debounceCandidates(evt, name, ballotCandidateId);
  };

  const debounceCandidates = useCallback(
    _.debounce((evt, name, ballotCandidateId) => {
      let newValue = '';
      if (name === 'ballotCandidatePartyId') {
        newValue = parseInt(evt.target.value);
      } else {
        newValue = evt.target.value;
      }

      const updBallot = {
        [name]: newValue,
        BallotId: props.ballotId,
        BallotCandidateId: ballotCandidateId,
      };
      axios
        .put(
          process.env.REACT_APP_API_BASE +
            'ballotCandidate/' +
            ballotCandidateId,
          updBallot,
          {
            headers: authHeader(),
          }
        )
        .then(props.setRerender(true));
      setState((prevState) => ({
        ...prevState,
        ['bg_' + name]: state['bg_' + name] ? false : true,
      }));
    }, 1000),
    []
  );

  const [state, setState] = useState({ candidates: initial });
  useEffect(() => {
    setState({ candidates: initial });
  }, [props.rerender]);

  function onDragEnd(result) {
    if (!result.destination) {
      return;
    }

    if (result.destination.index === result.source.index) {
      return;
    }

    const candidates = reorder(
      state.candidates,
      result.source.index,
      result.destination.index
    );

    setState({ candidates });
  }

  const handleFocus = (event) => event.target.select();
  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId='list'>
        {(provided) => (
          <div ref={provided.innerRef} {...provided.droppableProps}>
            {state.candidates.map((candidate, index) => (
              <Draggable
                draggableId={'candidate_' + candidate.ballotCandidateId}
                index={index}
              >
                {(provided) => (
                  <div
                    className='bg-wrapper-header'
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                  >
                    <div style={{ width: '100%' }}>
                      <table width='100%'>
                        <tr>
                          <td>{/*  <FaGripVertical /> */}</td>
                          <td>
                            <FormControl
                              type='textarea'
                              key={'bn_' + candidate.ballotCandidateId}
                              name={'bn_' + candidate.ballotCandidateId}
                              aria-label={`Candidate name for ${candidate.ballotCandidateName}`}
                              style={{ width: '100%' }}
                              defaultValue={candidate.ballotCandidateName}
                              onChange={(evt) =>
                                onChangeHandleCandidates(
                                  evt,
                                  'ballotCandidateName',
                                  candidate.ballotCandidateId
                                )
                              }
                              onFocus={handleFocus}
                              disabled={props.referendum}
                            />{' '}
                          </td>
                          <td>
                            {!props.referendum ? (
                              <FormControl
                                componentClass='select'
                                placeholder='select'
                                aria-label={`Candidate party for ${candidate.ballotCandidateName}`}
                                style={{
                                  width: '100%',
                                  marginLeft: '10px',
                                }}
                                onChange={(evt) =>
                                  onChangeHandleCandidates(
                                    evt,
                                    'ballotCandidatePartyId',
                                    candidate.ballotCandidateId
                                  )
                                }
                              >
                                <option value='select'></option>
                                {props.partyData.map((x) => (
                                  <option
                                    selected={
                                      candidate.ballotCandidatePartyId ===
                                      x.ballotCandidatePartyId
                                    }
                                    key={x.ballotCandidatePartyId}
                                    value={x.ballotCandidatePartyId}
                                  >
                                    {x.ballotCandidatePartyName}
                                  </option>
                                ))}
                                <option
                                  selected={
                                    candidate.ballotCandidatePartyId === 0
                                  }
                                  value='0'
                                >
                                  Independent
                                </option>
                              </FormControl>
                            ) : (
                              ''
                            )}
                          </td>
                          <td style={{ paddingLeft: '20px' }}>
                            {!props.referendum ? (
                              <button
                                type='button'
                                className='icon-button'
                                aria-label={`Delete candidate ${candidate.ballotCandidateName}`}
                                onClick={() =>
                                  deleteCandidate(candidate.ballotCandidateId)
                                }
                              >
                                <MdDelete
                                  className='delete-icon'
                                  size={26}
                                  title='remove candidate'
                                  aria-hidden='true'
                                />
                              </button>
                            ) : (
                              ''
                            )}
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>
                )}
              </Draggable>
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
};

export default DragDropCandidates;
